import { useSendEngraverPrinterData } from "@/queries/tasks/use-send-engraver-printer-data";
import { Task } from "@/queries/tasks/use-tasks";
import { useCallback } from "react";
import { MarkingTaskShared } from "./marking-task-shared";
import { useTaskParameter } from "@/queries/tasks/use-task-parameter";

export function EngraveTask({ task }: { task?: Task }) {
  const { sendEngraverPrinterData, isPending, isSuccess,error } =
    useSendEngraverPrinterData();

  const { taskParameter } = useTaskParameter({
    parameter: "GF_AutomaticallyEngrave",
    taskId: task?.Id,
  });

  const autoMark = taskParameter?.toLowerCase() === "true";

  const engrave = useCallback(() => {
    if (!task?.Id) return;

    sendEngraverPrinterData(task.Id);
  }, [sendEngraverPrinterData, task?.Id]);

  if (!task) return null;

  return (
    <MarkingTaskShared
      task={task}
      autoMark={autoMark}
      startedManually={isSuccess}
      isPending={isPending}
      onMark={engrave}
      error={error}
    />
  );
}
